import { authorizeGetRequest, authorizePostRequest } from "api";
import { IApiResponse, IPaginatedResponse, IPenaltyStatus } from "models";

// Get penalty status for a specific driver
export const getDriverPenaltyStatusApi = (driverId: string) => {
  return authorizeGetRequest<IPenaltyStatus>(
    `drivers/penalty/status/${driverId}`
  );
};

// Remove expired penalties
export const removeExpiredPenaltiesApi = () => {
  return authorizePostRequest<{ message: string; removed_count: number }>(
    `drivers/penalty/remove-expired`,
    {}
  );
};

// Remove penalty from a specific driver (admin action)
export const removeDriverPenaltyApi = (driverId: string) => {
  return authorizePostRequest<{ message: string; driver_id: string }>(
    `drivers/penalty/remove/${driverId}`,
    {}
  );
};

// Get all penalized drivers with pagination
export const getAllPenalizedDriversApi = (page: number = 1, per_page: number = 10) => {
  return authorizeGetRequest<IPaginatedResponse<IPenaltyStatus>>(
    `drivers/penalty/search?page=${page}&per_page=${per_page}`
  );
};

// Search penalized drivers by phone number and/or name with pagination
export const searchPenalizedDriversApi = (
  page: number = 1,
  per_page: number = 10,
  phone?: string,
  search?: string
) => {
  const params = new URLSearchParams();
  params.append('page', page.toString());
  params.append('per_page', per_page.toString());
  if (phone) params.append('phone', phone);
  if (search) params.append('search', search);

  return authorizeGetRequest<IPaginatedResponse<IPenaltyStatus>>(
    `drivers/penalty/search?${params.toString()}`
  );
};

// Manually trigger the daily anti-idle audit
export const runAntiIdleAuditApi = () => {
  return authorizePostRequest<{ status: string; message: string }>(
    `audit/run-anti-idle`,
    {}
  );
};

